/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_IntroInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_intro = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft can open and save Excel .xlsx workbooks. The useful question is whether your particular workbook survives the trip: its formulas, formatting and charts need checking after a save and reopen. This guide gives you a repeatable way to make that check without replacing your original.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_intro = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 可以打开和保存 Excel 的 .xlsx 工作簿。关键是你的具体文件经过编辑和保存后，公式、格式与图表是否仍然正确。本指南提供一套可重复的检查流程，并始终保留原始文件。`)
};

/**
* | output |
* | --- |
* | "GridCraft can open and save Excel .xlsx workbooks. The useful question is whether your particular workbook survives the trip: its formulas, formatting and ch..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_intro = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_intro(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_intro(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_intro as "gc.search_guides.gridcraft_excel_compatibility.intro" }